import { render, staticRenderFns } from "./TenderHeader.vue?vue&type=template&id=0a57cb60&"
import script from "./TenderHeader.vue?vue&type=script&lang=js&"
export * from "./TenderHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports